import { useEffect, useState } from 'react';
import { useLDFlag } from 'src/contexts/LaunchDarklyContext/LaunchDarklyContext';

export type FernSdkLanguage = 'go' | 'node';

// Each language has its own release gate so one can launch while another is
// still staging-only.
export const FERN_SDK_FLAGS: Record<FernSdkLanguage, string> = {
  go: 'docs-fern-sdk',
  node: 'docs-fern-sdk-node',
};

export function useFernSdkEnabled(language: FernSdkLanguage): boolean {
  const flag = useLDFlag(FERN_SDK_FLAGS[language], false);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  // Static HTML and the first hydration render must both show legacy examples.
  return hasMounted && flag === true;
}
